var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#fa1616;stroke-miterlimit:10;stroke-width:1.56px;}.c{fill:#fa1616;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002 0.001)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 9.402,
    y2: 12.301,
    transform: "translate(4.498 2.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9.1,1A7.9,7.9,0,0,0,1,9.1,8.1,8.1,0,0,0,8.9,17,8.1,8.1,0,0,0,17,8.9,8.1,8.1,0,0,0,9.1,1ZM14,13.6h-.3a3.4,3.4,0,0,0-1.2-1.2,6.8,6.8,0,0,0-3.5-1,6.8,6.8,0,0,0-3.5,1,3.4,3.4,0,0,0-1.2,1.2H4A7.2,7.2,0,0,1,2.2,9.1,6.9,6.9,0,0,1,9,2.2,6.8,6.8,0,0,1,15.7,9,6.6,6.6,0,0,1,14,13.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M9,4.7a2.4,2.4,0,0,0-1.9.8,2.4,2.4,0,0,0-.7,2A2.8,2.8,0,0,0,9,10.2a2.8,2.8,0,0,0,2.6-2.7,2.4,2.4,0,0,0-.7-2A2.7,2.7,0,0,0,9,4.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockedIcon);
export default __webpack_public_path__ + "static/media/blocked-icon.4d9e6e3d0c6ca52d57114d257a30ac30.svg";
export { ForwardRef as ReactComponent };